export const FINANCE_DESK_EN = {
    'finance.desk.col.cash': 'Cash',
    'finance.desk.col.latest_on': 'Latest statement',
    'finance.desk.col.counted': 'Accounts counted',
    'finance.desk.col.accounts': 'Bank accounts',
    'finance.desk.invoicing.desk_cash.title': 'Cash in the banks',
    'finance.desk.invoicing.desk_cash.detail': 'SAR · latest statement {latest_on}',
    'finance.desk.col.receivable': 'Owed',
    'finance.desk.col.overdue': 'Overdue',
    'finance.desk.col.overdue_count': 'Overdue documents',
    'finance.desk.col.open_count': 'Open documents',
    'finance.desk.invoicing.desk_receivables.title': 'Owed by customers',
    'finance.desk.invoicing.desk_receivables.detail': 'Of which {overdue} overdue',
    'finance.desk.col.due_week': 'Due this week',
    'finance.desk.col.bills': 'Vendor bills',
    'finance.desk.col.late': 'Already late',
    'finance.desk.col.until': 'Until',
    'finance.desk.invoicing.desk_payables.title': 'Owed to suppliers this week',
    'finance.desk.invoicing.desk_payables.detail': '{bills:purchasebills}',
    'finance.desk.col.net_due': 'Net due',
    'finance.desk.col.quarter': 'Quarter',
    'finance.desk.col.year': 'Year',
    'finance.desk.col.quarter_to': 'Quarter ends',
    'finance.desk.col.standing': 'Return',
    'finance.desk.col.output_vat': 'Output VAT',
    'finance.desk.col.input_vat': 'Input VAT',
    'finance.desk.invoicing.desk_vat.title': 'Value added tax',
    'finance.desk.invoicing.desk_vat.detail': '{quarter} {year} · ends {quarter_to} · {standing}',
    'finance.desk.quarter.q1': 'First quarter',
    'finance.desk.quarter.q2': 'Second quarter',
    'finance.desk.quarter.q3': 'Third quarter',
    'finance.desk.quarter.q4': 'Fourth quarter',
    'finance.desk.vat_standing.running': 'return after the quarter ends',
    'finance.desk.vat_standing.ended': 'return not marked filed',
    'finance.desk.vat_standing.filed': 'return filed',
    'finance.desk.subject.draft_customer_invoice': 'Invoice draft waiting to be issued',
    'finance.desk.subject.draft_credit_note': 'Credit note draft waiting to be issued',
    'finance.desk.subject.draft_debit_note': 'Debit note draft waiting to be issued',
    'finance.desk.subject.draft_vendor_bill': 'Vendor bill waiting to be posted',
    'finance.desk.subject.rejected': 'Refused by the authority',
    'finance.desk.subject.unmatched': 'Bank statement lines not matched',
    'finance.desk.subject.draft_entry': 'Manual entry waiting to be posted',
    'finance.desk.col.party': 'With whom',
    'finance.desk.col.amount': 'Amount',
    'finance.desk.col.since_days': 'Waiting',
    'finance.desk.col.number': 'Number',
    'finance.desk.col.id': 'Id',
    'finance.desk.col.party_id': 'Party',
    'finance.desk.col.subject': 'What',
    'finance.desk.col.document_id': 'Document',
    'finance.desk.col.state': 'State',
    'finance.desk.action.issue': 'Issue',
    'finance.desk.invoicing.desk_drafts.title': 'Sales drafts',
    'finance.desk.action.open': 'Open',
    'finance.desk.invoicing.desk_bills.title': 'Vendor bills to post',
    'finance.desk.unmatched.lines': '{lines:banklines}',
    'finance.desk.col.lines': 'Lines',
    'finance.desk.col.oldest_on': 'Oldest line',
    'finance.desk.action.match': 'Match',
    'finance.desk.invoicing.desk_unmatched.title': 'Bank lines not matched',
    'finance.desk.einvoicing.desk_rejected.title': 'E-invoices the authority refused',
    'finance.desk.accounting.desk_entries.title': 'Manual entries to post',
    'finance.desk.col.count': 'Documents',
    'finance.desk.invoicing.desk_collections.what': 'Collect {count:salesinvoices} from customers · {amount:money}',
    'finance.desk.col.what': ' ',
    'finance.desk.col.on': 'Date',
    'finance.desk.invoicing.desk_collections.title': 'Collections due',
    'finance.desk.invoicing.desk_bills_due.what': 'Pay {count:purchasebills} · {amount:money}',
    'finance.desk.invoicing.desk_bills_due.title': 'Vendor bills due',
    'finance.desk.invoicing.desk_recurring.what': 'Make {count:recurringinvoices}',
    'finance.desk.invoicing.desk_recurring.title': 'Recurring invoices to run',
    'finance.desk.col.label': 'Device',
    'finance.desk.col.days_left': 'Days left',
    'finance.desk.einvoicing.desk_certificates.what': 'The certificate of device {label} runs out',
    'finance.desk.einvoicing.desk_certificates.title': 'Device certificates',
    'finance.desk.col.status': 'Status',
    'finance.desk.accounting.desk_close.what': 'Close the period of {on:month}',
    'finance.desk.accounting.desk_close.title': 'Periods to close',
    'finance.desk.col.day': 'Day',
    'finance.desk.col.balance': 'Expected balance',
    'finance.desk.col.inflow': 'Coming in',
    'finance.desk.col.outflow': 'Going out',
    'finance.desk.col.notice': 'Notice',
    'finance.desk.forecast.note': 'Expected from the invoices and vendor bills falling due, from the latest bank statements. Nothing past due is counted, and nothing is read from the page in view.',
    'finance.desk.forecast.link': 'Bank accounts',
    'finance.desk.forecast.empty': 'Nothing falls due in the next 30 days.',
    'finance.desk.invoicing.desk_forecast.title': 'Cash over the next 30 days',
    'finance.desk.forecast.notice.no_statement': 'No bank statement gives a closing balance yet: the line starts at nought.',
    'finance.desk.col.oldest_days': 'Oldest',
    'finance.desk.overdue.note': 'What each owes past its due day. A name opens the customer’s page.',
    'finance.desk.overdue.link': 'Receivables aging',
    'finance.desk.overdue.empty': 'No customer is late.',
    'finance.desk.invoicing.desk_overdue.title': 'Most overdue customers',
    'unit.purchasebills.zero': '{n} vendor bills',
    'unit.purchasebills.one': '{n} vendor bill',
    'unit.purchasebills.two': '{n} vendor bills',
    'unit.purchasebills.few': '{n} vendor bills',
    'unit.purchasebills.many': '{n} vendor bills',
    'unit.purchasebills.other': '{n} vendor bills',
    'unit.salesinvoices.zero': '{n} invoices',
    'unit.salesinvoices.one': '{n} invoice',
    'unit.salesinvoices.two': '{n} invoices',
    'unit.salesinvoices.few': '{n} invoices',
    'unit.salesinvoices.many': '{n} invoices',
    'unit.salesinvoices.other': '{n} invoices',
    'unit.recurringinvoices.zero': '{n} recurring invoices',
    'unit.recurringinvoices.one': '{n} recurring invoice',
    'unit.recurringinvoices.two': '{n} recurring invoices',
    'unit.recurringinvoices.few': '{n} recurring invoices',
    'unit.recurringinvoices.many': '{n} recurring invoices',
    'unit.recurringinvoices.other': '{n} recurring invoices',
    'unit.waited.zero': '{n} days',
    'unit.waited.one': '{n} day',
    'unit.waited.two': '{n} days',
    'unit.waited.few': '{n} days',
    'unit.waited.many': '{n} days',
    'unit.waited.other': '{n} days',
    'unit.banklines.zero': '{n} lines',
    'unit.banklines.one': '{n} line',
    'unit.banklines.two': '{n} lines',
    'unit.banklines.few': '{n} lines',
    'unit.banklines.many': '{n} lines',
    'unit.banklines.other': '{n} lines',
};
export const FINANCE_DESK_AR = {
    'finance.desk.col.cash': 'النقد',
    'finance.desk.col.latest_on': 'آخر كشف',
    'finance.desk.col.counted': 'الحسابات المحسوبة',
    'finance.desk.col.accounts': 'الحسابات البنكية',
    'finance.desk.invoicing.desk_cash.title': 'النقد في البنوك',
    'finance.desk.invoicing.desk_cash.detail': 'ريال · آخر كشف {latest_on}',
    'finance.desk.col.receivable': 'المستحق',
    'finance.desk.col.overdue': 'المتأخر',
    'finance.desk.col.overdue_count': 'المستندات المتأخرة',
    'finance.desk.col.open_count': 'المستندات المفتوحة',
    'finance.desk.invoicing.desk_receivables.title': 'مستحق من العملاء',
    'finance.desk.invoicing.desk_receivables.detail': 'منها {overdue} متأخرة',
    'finance.desk.col.due_week': 'المستحق هذا الأسبوع',
    'finance.desk.col.bills': 'فواتير المشتريات',
    'finance.desk.col.late': 'متأخرة',
    'finance.desk.col.until': 'حتى',
    'finance.desk.invoicing.desk_payables.title': 'مستحق للموردين هذا الأسبوع',
    'finance.desk.invoicing.desk_payables.detail': '{bills:purchasebills}',
    'finance.desk.col.net_due': 'صافي المستحق',
    'finance.desk.col.quarter': 'الربع',
    'finance.desk.col.year': 'السنة',
    'finance.desk.col.quarter_to': 'نهاية الربع',
    'finance.desk.col.standing': 'الإقرار',
    'finance.desk.col.output_vat': 'ضريبة المخرجات',
    'finance.desk.col.input_vat': 'ضريبة المدخلات',
    'finance.desk.invoicing.desk_vat.title': 'ضريبة القيمة المضافة',
    'finance.desk.invoicing.desk_vat.detail': '{quarter} {year} · ينتهي {quarter_to} · {standing}',
    'finance.desk.quarter.q1': 'الربع الأول',
    'finance.desk.quarter.q2': 'الربع الثاني',
    'finance.desk.quarter.q3': 'الربع الثالث',
    'finance.desk.quarter.q4': 'الربع الرابع',
    'finance.desk.vat_standing.running': 'يُقدَّم الإقرار بعد نهاية الربع',
    'finance.desk.vat_standing.ended': 'لم يُسجَّل تقديم الإقرار',
    'finance.desk.vat_standing.filed': 'قُدِّم الإقرار',
    'finance.desk.subject.draft_customer_invoice': 'مسودة فاتورة تنتظر الإصدار',
    'finance.desk.subject.draft_credit_note': 'مسودة إشعار دائن تنتظر الإصدار',
    'finance.desk.subject.draft_debit_note': 'مسودة إشعار مدين تنتظر الإصدار',
    'finance.desk.subject.draft_vendor_bill': 'فاتورة مشتريات تنتظر الترحيل',
    'finance.desk.subject.rejected': 'رفضتها الهيئة',
    'finance.desk.subject.unmatched': 'أسطر في كشف البنك بلا مطابقة',
    'finance.desk.subject.draft_entry': 'قيد يدوي ينتظر الترحيل',
    'finance.desk.col.party': 'مع من',
    'finance.desk.col.amount': 'المبلغ',
    'finance.desk.col.since_days': 'منذ',
    'finance.desk.col.number': 'الرقم',
    'finance.desk.col.id': 'المعرّف',
    'finance.desk.col.party_id': 'الطرف',
    'finance.desk.col.subject': 'ماذا',
    'finance.desk.col.document_id': 'المستند',
    'finance.desk.col.state': 'الحالة',
    'finance.desk.action.issue': 'أصدر',
    'finance.desk.invoicing.desk_drafts.title': 'مسودات المبيعات',
    'finance.desk.action.open': 'افتح',
    'finance.desk.invoicing.desk_bills.title': 'فواتير مشتريات للترحيل',
    'finance.desk.unmatched.lines': '{lines:banklines}',
    'finance.desk.col.lines': 'الأسطر',
    'finance.desk.col.oldest_on': 'أقدم سطر',
    'finance.desk.action.match': 'طابق',
    'finance.desk.invoicing.desk_unmatched.title': 'أسطر البنك بلا مطابقة',
    'finance.desk.einvoicing.desk_rejected.title': 'فواتير رفضتها الهيئة',
    'finance.desk.accounting.desk_entries.title': 'قيود يدوية للترحيل',
    'finance.desk.col.count': 'المستندات',
    'finance.desk.invoicing.desk_collections.what': 'تحصيل {count:salesinvoices} من العملاء · {amount:money}',
    'finance.desk.col.what': ' ',
    'finance.desk.col.on': 'التاريخ',
    'finance.desk.invoicing.desk_collections.title': 'تحصيلات مستحقة',
    'finance.desk.invoicing.desk_bills_due.what': 'سداد {count:purchasebills} · {amount:money}',
    'finance.desk.invoicing.desk_bills_due.title': 'فواتير مشتريات مستحقة',
    'finance.desk.invoicing.desk_recurring.what': 'إصدار {count:recurringinvoices}',
    'finance.desk.invoicing.desk_recurring.title': 'فواتير متكررة',
    'finance.desk.col.label': 'الوحدة',
    'finance.desk.col.days_left': 'الأيام المتبقية',
    'finance.desk.einvoicing.desk_certificates.what': 'شهادة الوحدة {label} تنتهي',
    'finance.desk.einvoicing.desk_certificates.title': 'شهادات وحدات الحلول التقنية',
    'finance.desk.col.status': 'الحالة',
    'finance.desk.accounting.desk_close.what': 'إقفال فترة {on:month}',
    'finance.desk.accounting.desk_close.title': 'فترات للإقفال',
    'finance.desk.col.day': 'اليوم',
    'finance.desk.col.balance': 'الرصيد المتوقع',
    'finance.desk.col.inflow': 'الداخل',
    'finance.desk.col.outflow': 'الخارج',
    'finance.desk.col.notice': 'تنبيه',
    'finance.desk.forecast.note': 'المتوقع من الفواتير المستحقة وفواتير المشتريات المجدولة، ابتداءً من آخر كشوف البنوك. لا يُحسب المتأخر، ولا يُحسب شيء من الصفحة المعروضة.',
    'finance.desk.forecast.link': 'الحسابات البنكية',
    'finance.desk.forecast.empty': 'لا شيء يستحق خلال 30 يوماً.',
    'finance.desk.invoicing.desk_forecast.title': 'النقد خلال 30 يوماً',
    'finance.desk.forecast.notice.no_statement': 'لا كشف بنك فيه رصيد ختامي بعد: يبدأ الخط من الصفر.',
    'finance.desk.col.oldest_days': 'الأقدم',
    'finance.desk.overdue.note': 'ما على كل عميل بعد تاريخ استحقاقه. الضغط على الاسم يفتح صفحة العميل.',
    'finance.desk.overdue.link': 'أعمار الذمم',
    'finance.desk.overdue.empty': 'لا عميل متأخر.',
    'finance.desk.invoicing.desk_overdue.title': 'أكبر المتأخرات',
    'unit.purchasebills.zero': 'لا فواتير مشتريات',
    'unit.purchasebills.one': 'فاتورة مشتريات واحدة',
    'unit.purchasebills.two': 'فاتورتا مشتريات',
    'unit.purchasebills.few': '{n} فواتير مشتريات',
    'unit.purchasebills.many': '{n} فاتورة مشتريات',
    'unit.purchasebills.other': '{n} فاتورة مشتريات',
    'unit.salesinvoices.zero': 'لا فواتير',
    'unit.salesinvoices.one': 'فاتورة واحدة',
    'unit.salesinvoices.two': 'فاتورتين',
    'unit.salesinvoices.few': '{n} فواتير',
    'unit.salesinvoices.many': '{n} فاتورة',
    'unit.salesinvoices.other': '{n} فاتورة',
    'unit.recurringinvoices.zero': 'لا فواتير متكررة',
    'unit.recurringinvoices.one': 'فاتورة متكررة واحدة',
    'unit.recurringinvoices.two': 'فاتورتين متكررتين',
    'unit.recurringinvoices.few': '{n} فواتير متكررة',
    'unit.recurringinvoices.many': '{n} فاتورة متكررة',
    'unit.recurringinvoices.other': '{n} فاتورة متكررة',
    'unit.waited.zero': 'اليوم',
    'unit.waited.one': 'يوم واحد',
    'unit.waited.two': 'يومان',
    'unit.waited.few': '{n} أيام',
    'unit.waited.many': '{n} يوماً',
    'unit.waited.other': '{n} يوم',
    'unit.banklines.zero': 'لا أسطر',
    'unit.banklines.one': 'سطر واحد',
    'unit.banklines.two': 'سطران',
    'unit.banklines.few': '{n} أسطر',
    'unit.banklines.many': '{n} سطراً',
    'unit.banklines.other': '{n} سطر',
};
//# sourceMappingURL=i18n-finance-desk.js.map